import { Button, Container } from "reactstrap"
import BackButton from "../../../../../components/common/BackButton/BackButton"
import { Stepper } from "react-form-stepper"
import { useState } from "react"
import ProductSelection from "./ProductSelection/ProductSelection"
import styles from './ProductSubmission.module.scss'
import PriceAdjustment from "./PriceAdjustment/PriceAdjustment"
import Submission from "./Submission/Submission"

const ProductSubmission = () => {

  const [activeStep, setActiveStep] = useState(0)

  const steps = [{ label: "Product Selection" }, { label: "Price Adjustment" }, { label: "Submission" }]

  const handleClick = () => {
    if (activeStep < 2) {
      setActiveStep(activeStep + 1)
    }
  }

  return (
    <div style={{ background: "#f2f2f2", minHeight: "100dvh", paddingBlock: "1rem" }}>
      <Container fluid>
        <BackButton />

        <Stepper
          style={{ width: "100%" }}
          steps={steps}
          activeStep={activeStep}
          connectorStateColors={true}
          connectorStyleConfig={{
            completedColor: "#ffbd13",
            activeColor: "#ffbd13",
            disabledColor: "#eee",
          }}
          styleConfig={{
            activeBgColor: "#ffd813",
            completedBgColor: "#ffbd13",
            inactiveBgColor: "#eee",
            activeTextColor: "#111",
            completedTextColor: "#222",
            inactiveTextColor: "#444",
            circleFontSize: "0",
          }}
        />

        {activeStep === 0 && <ProductSelection handleClick={handleClick} />}
        {activeStep === 1 && <PriceAdjustment handleClick={handleClick} />}
        {activeStep === 2 && <Submission handleClick={handleClick} />}

      </Container>
    </div>
  )
}

export default ProductSubmission
